import React from "react";

const Account = () => {
  return (
    <div>
      <h1>Account</h1>
      <p>Content of the account page...</p>
    </div>
  );
};

export default Account;
